<h1 mat-dialog-title class="aligned-with-icon mt-3">
    <mat-icon
        class="mr-2"
        color="accent"
        [ngClass]="data.isWarning ? 'warn-color' : ''"
        >{{ data.icon }}</mat-icon
    >
    {{ data.title }}
</h1>
<div mat-dialog-content>
    <p [innerHTML]="htmlSanitizerService.getSanitizedText(data.summary)"></p>
</div>
<div mat-dialog-actions align="end">
    <button mat-raised-button mat-dialog-close>Close</button>
</div>
